import { XMLSerializer } from 'xmldom';
import constants from '../../Constants';

export function parseRubricBlockModel(rubricBlock) {
    const lang = rubricBlock.getAttribute('lang');
    const logicalName = rubricBlock.getAttribute(constants.contentAttributes.LOGICAL_NAME);
    const type = rubricBlock.getAttribute('type');
    const view = rubricBlock.getAttribute('view');
    const rubricBlockContent = new XMLSerializer().serializeToString(rubricBlock.childNodes);
    const xmlTextNode = document.createTextNode(rubricBlockContent);

    return {
        isMainMedia: false,
        rubricBlockContent,
        xmlTextNode,
        lang,
        logicalName,
        type,
        view,
    };
}

export function isRubricBlock(element) {
    return element.tagName === 'rubricBlock';
}

export function getRubricBlockModel(itemBodyElement) {
    const rubricBlock = itemBodyElement.getElementsByTagName('rubricBlock')[0];

    // For now only supporting Rubric Block intended for the candidate
    if (rubricBlock && rubricBlock.getAttribute('view') === 'candidate') {
        return parseRubricBlockModel(rubricBlock);
    }

    return undefined;
}
